import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

/**
 * Ponuka filtra „Riešiteľ" v správe podnetov: úradníci s prideleným
 * nálezom, ktorý prihlásený vidí. Rozsah počíta server, ten istý ako
 * pri zozname - meno riešiteľa z cudzej kategórie sem nepríde.
 */
export const adminGetReportsAssignees = createQueryFn(
  QueryNameSpace.adminGetReportsAssignees,
  async () => DigiobcanApi.adminGetReportsAssignees(),
);
